import fetchClient from "../utils/http-common";
import { SERVER_API_URL } from '../config/Constants'

// A day's playable puzzles. Defaults to today; pass a YYYY-MM-DD `date` to replay
// a past day (see the calendar). The response never includes the solution — moves
// are validated server-side (see step) so it can't be read off the wire.
const getDaily = (date) => {
  const q = date ? `?date=${encodeURIComponent(date)}` : '';
  return fetchClient.get(`${SERVER_API_URL}/puzzles/daily.json${q}`);
};

// The list of past days (YYYY-MM-DD) that have scheduled puzzles, for the calendar.
const getDates = () => {
  return fetchClient.get(`${SERVER_API_URL}/puzzles/dates.json`);
};

// Validate one attacker move against the (unique) solution line.
//   ply  : index of this move in the solution (0, 2, 4, ...)
//   move : "from,to" of the piece the player just dropped
// Returns { correct, solved?, reply? }. The solution never reaches the client.
const step = (puzzleId, ply, move) => {
  return fetchClient.post(`${SERVER_API_URL}/puzzles/${puzzleId}/step.json`, {
    ply,
    move,
  });
};

export default {
  getDaily,
  getDates,
  step,
};
